import { defineComponent } from 'vue';
import './index.less';

export default defineComponent({
  name: 'PageView',
  created() {
    const userName = sessionStorage.getItem('userName');
    // if (!userName) {
    //   this.$router.push('/auth/login');
    // }
  },
  render() {
    return <router-view class="body" />;
  },
});
